module.exports = __webpack_public_path__ + "static/media/Manual Hoja de vida.0445a7dc.pdf";